export default __webpack_public_path__ + "static/media/logo.2347a3f0.png";